import { useState } from "react";
import { device, type NavigationTypes } from "web_myplann/Utils/device";

export const useOpenCalculator = () => {
	const [isOpeningCalculator, setIsOpeningCalculator] = useState(false);

	const openCalculator = async (
		type: keyof typeof NavigationTypes,
	): Promise<void> => {
		setIsOpeningCalculator(true);
		try {
			await device.navigationRequest(type);
		} catch {
		} finally {
			setIsOpeningCalculator(false);
		}
	};

	return { openCalculator, isOpeningCalculator };
};
